module.exports = __webpack_public_path__ + "img/lessonattend-finger-blue.45bb74e2.svg";